import * as Amplitude from '@amplitude/analytics-browser';

export type AmplitudeEvent =
	| 'Welcome Screen'
	| 'Start Register'
	| 'Fullname Screen'
	| 'Fullname Submit'
	| 'CPF Screen'
	| 'CPF Submit'
	| 'Gender Screen'
	| 'Gender Selected'
	| 'Birthday Screen'
	| 'Birthday Submit'
	| 'Address Screen'
	| 'Address Submit'
	| 'Phone Screen'
	| 'Phone Submit'
	| 'Email Screen'
	| 'Email Submit'
	| 'Password Screen'
	| 'Show Password'
	| 'Password Submit'
	| 'Terms and Policies Screen'
	| 'Check Agreement'
	| 'Create Account Clicked'
	| 'Register Done Screen'
	| 'Fill CV Clicked'
	| 'Not Now Clicked'
	| 'PCD Screen'
	| 'PCD Submit'
	| 'Marital Screen'
	| 'Marital Submit'
	| 'Nationality Screen'
	| 'Nationality Submit'
	| 'Salary Screen'
	| 'Salary Submit'
	| 'Professional Goals Screen'
	| 'Professional Goals Submit'
	| 'Professional Data Screen'
	| 'Professional Data Submit'
	| 'Work Experience Screen'
	| 'Work Experience Positive Clicked'
	| 'Work Experience Negative Clicked'
	| 'Register Role Experience Screen'
	| 'Register Role Experience Submit'
	| 'Company Name Experience Screen'
	| 'Company Name Experience Submit'
	| 'Activities Experience Screen'
	| 'Activities Experience Submit'
	| 'Working on Company Question Screen'
	| 'Working on Company Positive Clicked'
	| 'Working on Company Negative Clicked'
	| 'Experience Begin Date Screen'
	| 'Experience Begin Date Submit'
	| 'Experience End Date Screen'
	| 'Experience End Date Submit'
	| 'Register Another Experience Question Screen'
	| 'Register Another Experience Positive Clicked'
	| 'Register Another Experience Negative Clicked'
	| 'Education Screen'
	| 'Education Selected'
	| 'School name Screen'
	| 'School name Submit'
	| 'Education Title Name Screen'
	| 'Education Title Name Submit'
	| 'Education Status Question Screen'
	| 'Education Status Not Finished Selected'
	| 'Education Status Finished Selected'
	| 'Education Begin Date Screen'
	| 'Education Begin Date Submit'
	| 'Education End Date Screen'
	| 'Education End Date Submit'
	| 'Course Question Screen'
	| 'Course Question POSITIVE Screen'
	| 'Course Question NEGATIVE Screen'
	| 'Course Type Question Screen'
	| 'Course Type Selection'
	| 'Language Question Screen'
	| 'Language Selected'
	| 'Presentation Letter Screen'
	| 'Presentation Letter Submit'
	| 'Register Congratulations Screen'
	| 'Acess/Download CV Clicked';

export class AmplitudeService {
	private static _instance: Amplitude.Types.BrowserClient;

	private static initialize() {
		if (process.env.NODE_ENV !== 'production') return;
		if (!AmplitudeService._instance) {
			AmplitudeService._instance = Amplitude.createInstance();
			const amplitudeApiKey = process.env.REACT_APP_AMPLITUDE_API_KEY!;
			AmplitudeService._instance.init(amplitudeApiKey);
		}
	}

	public static track(
		eventInput: AmplitudeEvent,
		eventProperties?: Record<string, any> | undefined,
	) {
		if (process.env.NODE_ENV !== 'production') return;
		AmplitudeService.initialize();
		AmplitudeService._instance.track(eventInput, eventProperties);
	}

	public static setUserForTracking(input: {
		id: string;
		email: string;
		birthday: string;
	}) {
		if (process.env.NODE_ENV !== 'production') return;
		AmplitudeService.initialize();
		AmplitudeService._instance.setUserId(input.id);
		const identify = new Amplitude.Identify();
		identify.set('id', input.id);
		identify.set('email', input.email);
		identify.set('birthday', input.birthday);
		identify.set('signup', 'chatbot');
		AmplitudeService._instance.identify(identify);
	}
}
